import { render, staticRenderFns } from "./ScheduleAppointmentDetail.vue?vue&type=template&id=494b6800&scoped=true"
import script from "./ScheduleAppointmentDetail.vue?vue&type=script&lang=js"
export * from "./ScheduleAppointmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b6800",
  null
  
)

export default component.exports